module.exports = __webpack_public_path__ + "static/media/hero-students.3904a11d.jpg";